import DialogColor from "./dialogColor";

export default class DialogConfig {
  constructor(title, content, contentUrl, type) {
    this.title = title;
    this.content = content;
    this.contentUrl = contentUrl;
    this.type = type;
  }

  static red(content, title) {
    return new DialogConfig(
      title,
      content,
      null,
      DialogColor.RED
    );
  } 
  
  static primary(content, title) {
    return new DialogConfig(
      title,
      content,
      null,
      DialogColor.ORANGE
    );
  } 

  static success(content, title) {
    return new DialogConfig(
      title,
      content,
      null,
      DialogColor.GREEN
    );
  }
}


// WEBPACK FOOTER //
// ./client/app/common/models/dialog/dialogConfig.js